import { SkeletonBox, Space } from '@billy/design-system'
import { Fragment, type ReactElement } from 'react'

// Heights of the four groups in LogoAndBrandingSettingsFormFields, each at full width.
// Logo: 20px label + 6px gap + 150px dropzone.
// Font and color: 20px label + 4px gap + 50px control.
// Apply color: 20px title + four 52px switch rows + three 1px dividers.
const logoAndBrandingSettingsFormFieldsSkeletons = [
  { height: 176, id: 'logo' },
  { height: 74, id: 'font' },
  { height: 74, id: 'color' },
  { height: 231, id: 'apply-color' },
]

export const LogoAndBrandingSettingsFormFieldsSkeletons = (): ReactElement => (
  <>
    {logoAndBrandingSettingsFormFieldsSkeletons.map(({ height, id }, index) => (
      <Fragment key={id}>
        {index > 0 && <Space />}
        <SkeletonBox fullWidth height={height} />
      </Fragment>
    ))}
  </>
)
